import { useLocalStorage } from 'react-use';

export function useReturnTo() {
  return useLocalStorage('returnTo');
}
